export const getColorByBgColor = (bgColor: string | undefined) => {
    if (!bgColor) { return '#fff'; }
    return (parseInt(bgColor.replace('#', ''), 16) > 0xffffff / 4 * 3) ? '#000' : '#fff';
}

export const adjustColor = (color: string | undefined) => {
    if (!color) { return '#00'; }
    return (parseInt(color.replace('#', ''), 16) > 0xffffff / 4 * 3) ? '#000' : color;
}